import { LoadingOverlay } from "@mantine/core";
import EmailPreviewer from "./EmailPreviewer";
import { useEffect, useState } from "react";
import { findWorkflow } from "../../api/WorkflowAPI";
import { useLeadsSheetStore } from "../../stores/LeadsStore";

const EmailPreviewPrm = ({ opened, prog_id, step_id, onModelFound }) => {
  const [loading, setLoading] = useState(false);
  const [modelId, setModelId] = useState(null);
  const [signId, setSignId] = useState(null);
  const current = useLeadsSheetStore((s) => s.current);

  useEffect(() => {
    if (opened) {
      setLoading(true);
      let workflow_id = current.programmations.find(
        (x) => x.programmation_id === prog_id
      )?.workflow_id;

      if (workflow_id) {
        findWorkflow(workflow_id)
          .then((res) => {
            let workflowProfile = res.data.workflow_profile;

            let step = workflowProfile.steps.find(
              (x) => x.step_id.id === step_id
            );

            let model_id = step.model_id;
            let signature_id = step.signature_id;

            setModelId(model_id);
            setSignId(signature_id);
          })
          .finally(() => setLoading(false));
      }
    }
  }, [opened]);

  return (
    <>
      <LoadingOverlay visible={loading} />
      <EmailPreviewer
        key={modelId}
        model_id={modelId}
        iframeHeight={400}
        paperShadow="none"
        signatureId={signId}
        contact={current}
        prog_id={prog_id}
        noTokenReplace
        onModelFound={onModelFound}
      />
    </>
  );
};

export default EmailPreviewPrm;
